<template>
  <p class="text-small text-color-error">
    {{ text }}
  </p>
</template>

<script>
export default {
  name: 'ErrorText',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
}
</script>
